export class byLawsReportParam {
    entityRegName: string;
    entityRegNumber: string;
    hTMLTemplate: string;
}
